module.exports = function getResource(label, vars = []) {
    const resources = { saleCopy: 'Solde' };

    return resources[label];
};
